import { getElement, ifSelectorExist, getCookie } from './utils';

export const showAllAreas = () => {
  let button = getElement('.millers-areas__content_btn');
  let content = getElement('.millers-areas__content');
  if (ifSelectorExist(button)) {
    button.addEventListener("click", (event) => {
      if (ifSelectorExist(content)) {
        content.classList.add("open-all");
        button.remove();
      }
    });
  }
}